import { render, staticRenderFns } from "./ArtificialIntelligence.vue?vue&type=template&id=5ad45ee5"
import script from "./ArtificialIntelligence.vue?vue&type=script&lang=js"
export * from "./ArtificialIntelligence.vue?vue&type=script&lang=js"
import style0 from "./ArtificialIntelligence.vue?vue&type=style&index=0&id=5ad45ee5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports